import { createListenerMiddleware } from '@reduxjs/toolkit';

import { resetSession } from '@/shared/api';

import { sessionActions } from '../slices/session.slice';

export const resetSessionListener = createListenerMiddleware();

const startResetSessionListener =
    resetSessionListener.startListening as TypedListening;

startResetSessionListener({
    actionCreator: resetSession,
    effect: (tokens, { dispatch }) => {
        dispatch(sessionActions.reset(tokens.payload));
    },
});
